import { sortBy, uniq } from 'lodash'
import { useQuery } from 'react-query'
import UserSettingsService from '../services/UserSettingsService'

const useUserSettingsByEmails = (emails: string[], enabled: boolean = true) => {
  const sortedAndUniqueEmails = sortBy(uniq(emails), email => email?.toLowerCase()).filter(
    email => !!email?.trim()
  )

  const { data } = useQuery(
    ['userSettingsByEmails', sortedAndUniqueEmails],
    async () => {
      const { data } = await UserSettingsService.getByEmails(emails)
      return data
    },
    {
      enabled: sortedAndUniqueEmails.length > 0 && enabled,
      keepPreviousData: true,
    }
  )

  const getUserSettings = (email: string) => {
    if (!email || !data) {
      return undefined
    }

    return data?.find(user =>
      [user.emailAddress?.toLowerCase(), user.preferredEmailAddress?.toLowerCase()].includes(
        email?.toLowerCase()
      )
    )
  }

  return {
    data: data ?? [],
    getUserSettings,
  }
}

export default useUserSettingsByEmails
